import type { QueryMeta } from '@unifyapps/network/utils/fetch';
import type { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import type { ClientContextValue } from '../../context/client/types';
import { ClientType } from '../../context/client/types';
import getEnabledItems from '../../utils/getEnabledItems';
import { getPersistSourceInRouteMiddleware } from '../project/getPersistSourceInRouteMiddleware';
import {
  getAdaptedProjectsRouteMiddleware,
  getRouteWithSourceInfoMiddleware,
  getUrlWithBasePath,
  getUrlWithUAPath,
} from '../project/utils';

export interface ExtendedNavigateOptions extends NavigateOptions {
  pId?: number;
  source?: string;
  sourcePayload?: Record<string, unknown>;
  persistSourceInfo?: boolean;
  useNativeRouter?: boolean;
}

/**
 * Middleware pipeline to process the URL through various transformations
 */
export function processUrl(
  url: string,
  options?: ExtendedNavigateOptions,
  context?: { projectSlug?: string; client: ClientContextValue['client']; queryMeta?: QueryMeta },
): string {
  return getEnabledItems([
    {
      // Projects routes are only relevant for the Platform client or Delta platform clients
      enabled:
        context?.client === ClientType.Platform || context?.client === ClientType.DeltaPlatform,
      fn: getAdaptedProjectsRouteMiddleware,
    },
    {
      enabled: true,
      fn: getRouteWithSourceInfoMiddleware,
    },
    {
      // Persist source info is only relevant for Delta platform clients
      // enabled: context?.client === ClientType.DeltaPlatform,
      fn: getPersistSourceInRouteMiddleware,
    },
    {
      // Add base path to the in the path
      fn: getUrlWithBasePath,
      enabled: !options?.useNativeRouter,
    },
    {
      // handle /ua/ pages for matrix platform pages
      fn: getUrlWithUAPath,
    },
  ]).reduce((currentUrl, { fn }) => {
    return fn(currentUrl, options, {
      projectSlug: context?.projectSlug,
      queryMeta: context?.queryMeta,
    });
  }, url);
}
